import React from 'react';

/**
 * Captura qualquer erro de render para evitar "tela preta" total.
 * Mostra mensagem amigável + botão de recarregar.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught:', error, info);
    this.setState({ info });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, info: null });
  };

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="min-h-screen flex items-center justify-center bg-background p-4">
        <div className="max-w-lg w-full bg-card border border-border rounded-2xl shadow-xl p-6 space-y-4" data-testid="error-boundary">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center">
              <span className="text-2xl">!</span>
            </div>
            <div>
              <h2 className="text-lg font-semibold text-foreground">Algo deu errado</h2>
              <p className="text-sm text-muted-foreground">A tela travou ao renderizar. Seus dados estão seguros.</p>
            </div>
          </div>

          <div className="bg-muted rounded-lg p-3 text-xs font-mono text-red-700 dark:text-red-300 max-h-40 overflow-auto">
            {String(this.state.error?.message || this.state.error || 'Erro desconhecido')}
          </div>

          <div className="flex items-center gap-2 justify-end">
            <button
              onClick={this.handleReset}
              className="px-4 py-2 rounded-lg border border-border hover:bg-accent text-sm font-medium"
              data-testid="error-boundary-retry"
            >
              Tentar novamente
            </button>
            <button
              onClick={this.handleReload}
              className="px-4 py-2 rounded-lg bg-primary text-primary-foreground hover:opacity-90 text-sm font-medium"
              data-testid="error-boundary-reload"
            >
              Recarregar página
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
